import { isSameDay } from 'date-fns';

export const checkComplianceActive = (complianceEndDate: string) => {
  const currentDate = new Date();
  const formattedComplianceEndDate = new Date(complianceEndDate);

  return currentDate < formattedComplianceEndDate
    || isSameDay(formattedComplianceEndDate, currentDate);
};
